import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Notification extends Component {
  constructor() {
    super();

    this.state = {
      active: true
    };

    this.close = this.close.bind(this);
  }

  setClasses() {
    const base = 'notification';
    const classNames = [base];
    const { active } = this.state;
    const { status } = this.props;

    if (!active) {
      classNames.push(`${base}--closed`);
    }

    if (status) {
      classNames.push(`${base}--${status}`);
    }

    return classNames.join(' ');
  }

  close() {
    const { callback } = this.props;
    this.setState({ active: false }, callback);
  }

  render() {
    const { message, size } = this.props;

    return (
      <div className={this.setClasses()}>
        <div className="notification__container">
          <p
            className={`notification__message ${
              size ? `notification__message--${size}` : ''
            }`}
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <button
            className="notification__close"
            onClick={() => this.close()}
          />
        </div>
      </div>
    );
  }
}

Notification.defaultProps = {
  message: '',
  callback: () => {},
  status: '',
  size: ''
};

Notification.propTypes = {
  message: PropTypes.string,
  callback: PropTypes.func,
  status: PropTypes.string,
  size: PropTypes.string
};

export default Notification;
